import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"

function useStyles() {
    const { breakpoints } = useTheme()
    const { colors: color } = useContextState()
    return {
        hg100: {
            height: '100%'
        },
        hg90: {
            minHeight: '95%'
        },
        headerLeft: {
            display: 'flex',
            width: 'fit-content',
            alignItems: 'center',
            '& .MuiIconButton-root': {
                color: color.color4,
                fontWeight: '600',
                marginLeft: '-10px',
            },
            '& .MuiTypography-root': {
                fontSize: '17px',
                fontWeight: '400',
                color: color.color4,
            }
        },
        buttonsContainer: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .back': {
                width: '80px',
                height: '36px',
                /* textTransform: 'uppercase', */
            },
            '& .next': {
                borderRadius: '4px',
                /* textTransform: 'uppercase', */
            },
        },
        headerTitle: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .MuiTypography-root': {
                fontSize: '20px',
                fontWeight: '500',
                //color: colors.color13,
                '& span': {
                    color: color.color16,
                },
                marginBottom: '20px',
            },
        },
        containerFilter: {
            display: 'flex',
            gap: 2
        },
        drawerfilter: {
            height: '40px',
            width: '40px'
        },
        section: {
            marginBottom: '32px',
        },
        clean: {
            fontSize: '2rem',
            padding: '6px',
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
        },
        hide: {
            visibility: 'hidden',
        },
    }
}

export { useStyles }